export default __webpack_public_path__ + "static/media/9.25ca7083.png";